var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.962,
    height: 42.543,
    viewBox: "0 0 31.962 42.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-color",
    transform: "translate(-31.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_81",
    "data-name": "Trac\\xE9 81",
    d: "M63.416,29.646V9.689a2.137,2.137,0,0,0-.63-1.52L55.247.63A2.136,2.136,0,0,0,53.727,0H33.605a2.152,2.152,0,0,0-2.15,2.15v27.5A133.515,133.515,0,0,0,63.416,29.646Z",
    transform: "translate(0 0)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_82",
    "data-name": "Trac\\xE9 82",
    d: "M31.455,176.232v10.747a2.152,2.152,0,0,0,2.15,2.15H61.266a2.152,2.152,0,0,0,2.15-2.15V176.232Z",
    transform: "translate(0 -146.586)",
    fill: "#ea5440"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_83",
    "data-name": "Trac\\xE9 83",
    d: "M169.359,51.732l8.764,8.731-.038-8.107Z",
    transform: "translate(-114.705 -43.03)",
    fill: "#c4cbd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84",
    "data-name": "Trac\\xE9 84",
    d: "M174.693,8.341,167.155.8A2.129,2.129,0,0,0,166,.208V7.479A2.024,2.024,0,0,0,168.017,9.5h7.271A2.132,2.132,0,0,0,174.693,8.341Z",
    transform: "translate(-111.907 -0.173)",
    fill: "#abb2b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_85",
    "data-name": "Trac\\xE9 85",
    d: "M79.844,191.982H77.776a.591.591,0,0,0-.591.591v6.444a.591.591,0,1,0,1.182,0v-2.028h1.477a1.935,1.935,0,0,0,1.932-1.932v-1.142A1.935,1.935,0,0,0,79.844,191.982Zm.751,3.074a.751.751,0,0,1-.751.751H78.367v-2.643h1.477a.751.751,0,0,1,.751.751Z",
    transform: "translate(-38.037 -159.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_86",
    "data-name": "Trac\\xE9 86",
    d: "M114.976,199.608h-1.929a.591.591,0,0,1-.591-.591v-6.444a.591.591,0,0,1,.591-.591h1.93a2.073,2.073,0,0,1,2.07,2.07v3.484A2.073,2.073,0,0,1,114.976,199.608Zm-1.338-1.182h1.339a.89.89,0,0,0,.889-.889v-3.484a.89.89,0,0,0-.889-.889h-1.339Z",
    transform: "translate(-67.375 -159.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_87",
    "data-name": "Trac\\xE9 87",
    d: "M152.424,191.982h-3.409a.591.591,0,0,0-.591.591v6.444a.591.591,0,1,0,1.182,0v-2.631h1.642a.591.591,0,1,0,0-1.182h-1.642v-2.04h2.818a.591.591,0,0,0,0-1.182Z",
    transform: "translate(-97.292 -159.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_88",
    "data-name": "Trac\\xE9 88",
    d: "M107.4,81.123a.472.472,0,0,0-.437-.292h-2.271V75.264a.473.473,0,0,0-.473-.473H98.158a.473.473,0,0,0-.473.473v5.568H95.414a.473.473,0,0,0-.334.807l5.773,5.773a.472.472,0,0,0,.668,0l5.773-5.773A.473.473,0,0,0,107.4,81.123Z",
    transform: "translate(-52.806 -62.209)",
    fill: "#c4cbd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_89",
    "data-name": "Trac\\xE9 89",
    d: "M101.777,75.5a.472.472,0,0,0-.437-.292H99.069V69.644a.473.473,0,0,0-.473-.473H92.538a.473.473,0,0,0-.473.473v5.568H89.794a.473.473,0,0,0-.334.807l5.773,5.773a.472.472,0,0,0,.668,0l5.773-5.773A.473.473,0,0,0,101.777,75.5Z",
    transform: "translate(-48.131 -57.535)",
    fill: "#ea5440"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfColor);
export default __webpack_public_path__ + "static/media/pdf-color.28ee5a258b1fbedc357c7d037daa0ac2.svg";
export { ForwardRef as ReactComponent };